<template>
  <div class="the-navbar__user-meta flex items-center">

    <div class="text-right leading-tight hidden sm:block" v-if="currentUser">
       <p class="font-semibold">{{ userName }}</p>
       <small>{{ userLogin }}</small>
    </div>

    <vs-dropdown class="cursor-pointer" vs-custom-content vs-trigger-click>

      <div class="con-img ml-3">
<!--        <img :src="userPhoto" @error="onImageError"
             class="rounded-full shadow-md cursor-pointer block"
             height="40" key="onlineImg"
             v-if="userPhoto" width="40"/>-->
        <vs-avatar
          :src="userPhoto" class="rounded-full shadow-md cursor-pointer block m-0"
          size="40px"/>
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">

          <li @click="goToProfilePage"
            v-if="currentUser"
              class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4"/>
            <span class="ml-2">{{$t('layout.nav-bar.profile')}}</span>
          </li>

          <li @click="goToPM"
            v-if="currentUser"
              class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <feather-icon icon="MailIcon" svgClasses="w-4 h-4"/>
            <span class="ml-2">{{$t('layout.nav-bar.inbox')}}</span>
          </li>

          <!-- <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <feather-icon icon="MessageSquareIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">{{$t('layout.nav-bar.chat')}}</span> &ndash;&gt;
          </li>-->

          <vs-divider class="m-1"/>

          <li
            @click="logout"
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4"/>
            <span class="ml-2">{{$t('layout.nav-bar.logout')}}</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>

  import store from '@/store';
  import {createHelpers} from 'vuex-map-fields';
  import {createNamespacedHelpers} from "vuex";
  import User from '../../../../store/modules/user';
  import {getAvatarUrl, getXRegisStudentPhoto} from "@/utils/upload";

  if (!store.state.User) store.state.registerModule(`User`, User);

  const {
    mapActions: mapUserActions,
  } = createNamespacedHelpers(`User`);

  const {
    mapFields: mapUserFields,
  } = createHelpers({
    getterType: `User/getField`,
    mutationType: `User/updateField`,
  });

  export default {
    data() {
      return {}
    },
    computed: {
      ...mapUserFields({
        currentUser: 'currentUser',
      }),
      userPhoto() {
        if (this.currentUser) {
          return getXRegisStudentPhoto(this.currentUser.userLogin);
        }
        return getXRegisStudentPhoto('');
      },
      userName(){
        if (this.currentUser) {
          return `${this.currentUser.nameLocal} ${this.currentUser.surnameLocal}`
        }
        return '';
      },
      userLogin(){
        if (this.currentUser) {
          return this.currentUser.userLogin;
        }
        return '';
      },
    },
    methods: {
      ...mapUserActions({
        getCurrentUser: 'getCurrentUser',
      }),
      logout() {
        this.$store.dispatch("User/signOut", this);
      },
      goToProfilePage() {
        this.$router.push("/profile");
      },
      goToPM() {
        if(this.$route.path !== '/pm') {
          this.$router.push("/pm");
        }
      },
      /*async connectWithXRegis() {
        const sharingid = await this.$store.dispatch("shareUserProfileOnce", null, {
          root: true
        });

        if (sharingid) {
          const query = `appname=xstudi&apptype=student&sharingid=${sharingid}`;
          console.log(this.$store.state.currentUser);
          const uuid = this.$store.state.currentUser.uuid;
          window.open(`${VUE_APP_XREGIS_WEBAPP}/connect/${uuid}?${query}`, '_blank');
        }

      },*/
      onImageError(image){
        image.onerror = null;
        image.src = getAvatarUrl('');
        this.$forceUpdate();
        return image;
      }
    },
    async beforeMount() {
      await this.getCurrentUser();
    }
  }
</script>
